// Создано tools/capture/reach.mjs — не править руками.
/** Бьющая конечность в первый активный кадр удара: кость и где она от стоп — вперёд и вверх, пиксели мира. */
export const LIMB_REACH: Readonly<
  Record<string, { readonly limb: string; readonly forward: number; readonly up: number }>
> = {
  "air-heavy": { limb: "mixamorigLeftHand", forward: 64.2, up: 113.9 },
  "air-kick": { limb: "mixamorigLeftHand", forward: 35.2, up: 109.2 },
  "air-punch": { limb: "mixamorigLeftHand", forward: 35.2, up: 109.2 },
  "back-body-hook": { limb: "mixamorigLeftHand", forward: 52.5, up: 133.4 },
  "back-cross": { limb: "mixamorigLeftHand", forward: 55.5, up: 133.5 },
  "back-kick": { limb: "mixamorigLeftToeBase", forward: 73.8, up: 91 },
  "body-hook": { limb: "mixamorigLeftHand", forward: 52.5, up: 133.4 },
  "charged-kick": { limb: "mixamorigRightToeBase", forward: 63.8, up: 134.2 },
  "charged-punch": { limb: "mixamorigLeftHand", forward: 55.5, up: 133.5 },
  "close-elbow": { limb: "mixamorigRightForeArm", forward: 43.4, up: 108.7 },
  cross: { limb: "mixamorigLeftHand", forward: 55.5, up: 133.5 },
  "crouch-jab": { limb: "mixamorigRightHand", forward: 44.9, up: 47.9 },
  "crouch-kick": { limb: "mixamorigRightToeBase", forward: 58.7, up: 3.4 },
  "dash-strike": { limb: "mixamorigLeftHand", forward: 64.2, up: 113.9 },
  "drop-kick": { limb: "mixamorigRightToeBase", forward: 66.8, up: 69.6 },
  "elbow-lunge": { limb: "mixamorigLeftForeArm", forward: 29.4, up: 96.4 },
  "flip-kick": { limb: "mixamorigRightToeBase", forward: 83.8, up: 104.1 },
  "front-kick": { limb: "mixamorigLeftToeBase", forward: 73.8, up: 91 },
  "heavy-kick": { limb: "mixamorigRightToeBase", forward: 63.8, up: 134.2 },
  "high-jab": { limb: "mixamorigLeftHand", forward: 55.5, up: 133.5 },
  "high-sweep": { limb: "mixamorigRightToeBase", forward: 82.6, up: 7.8 },
  "high-uppercut": { limb: "mixamorigLeftHand", forward: 52.2, up: 122.3 },
  hook: { limb: "mixamorigRightHand", forward: 49.3, up: 129.2 },
  "hook-elbow": { limb: "mixamorigLeftForeArm", forward: 42.9, up: 120.3 },
  "hook-high-kick": { limb: "mixamorigRightToeBase", forward: 63.8, up: 134.2 },
  "hook-jab": { limb: "mixamorigLeftHand", forward: 56.1, up: 79.4 },
  "hook-kick": { limb: "mixamorigLeftToeBase", forward: 73.8, up: 91 },
  hurricane: { limb: "mixamorigLeftToeBase", forward: 73.8, up: 93.3 },
  jab: { limb: "mixamorigLeftHand", forward: 56.1, up: 79.4 },
  "jab-high-kick": { limb: "mixamorigRightToeBase", forward: 63.8, up: 134.2 },
  "jab-kick": { limb: "mixamorigRightToeBase", forward: 75.8, up: 94.5 },
  "kick-cross": { limb: "mixamorigLeftHand", forward: 55.5, up: 133.5 },
  "kick-elbow": { limb: "mixamorigLeftForeArm", forward: 29.4, up: 96.4 },
  "kick-high": { limb: "mixamorigRightToeBase", forward: 63.8, up: 134.2 },
  "lead-hook": { limb: "mixamorigRightHand", forward: 49.3, up: 129.2 },
  "light-kick": { limb: "mixamorigRightToeBase", forward: 75.8, up: 94.5 },
  "low-kick-series": { limb: "mixamorigRightToeBase", forward: 58.7, up: 3.4 },
  "low-sweep-finale": { limb: "mixamorigRightToeBase", forward: 82.6, up: 7.8 },
  "low-uppercut": { limb: "mixamorigLeftHand", forward: 52.2, up: 122.3 },
  "overhand-elbow": { limb: "mixamorigRightForeArm", forward: 43.4, up: 108.7 },
  "rise-kick": { limb: "mixamorigRightToeBase", forward: 67.7, up: 85.2 },
  "rising-elbow": { limb: "mixamorigLeftForeArm", forward: 42.9, up: 120.3 },
  "rising-strike": { limb: "mixamorigLeftHand", forward: 52.2, up: 122.3 },
  "run-knee": { limb: "mixamorigRightLeg", forward: 33.3, up: 68.7 },
  "run-slide": { limb: "mixamorigLeftToeBase", forward: 82.4, up: 8.8 },
  "series-finisher": { limb: "mixamorigLeftHand", forward: 52.2, up: 122.3 },
  "spin-kick": { limb: "mixamorigLeftToeBase", forward: 81.3, up: 110 },
  "step-kick": { limb: "mixamorigLeftToeBase", forward: 73.8, up: 91 },
  sweep: { limb: "mixamorigRightToeBase", forward: 82.6, up: 7.8 },
  uppercut: { limb: "mixamorigLeftHand", forward: 52.2, up: 122.3 },
};
